module.exports = __webpack_public_path__ + "assets/img/NPC014.a60979fd.png";